export function randomNumberBetweenRange(min = 1, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
